export const baseData = {
  title: "DIVISI"
}